export const QUERY__TOPICS = 'topics';
export const QUERY__TOPIC_INFINITE_LIST = 'topic-infinite-list';
export const QUERY__TOPIC = 'topic';
export const QUERY__TOPIC_EVENTS = 'topic-events';
